
<template>
  <div class="ur-dropdown ur-input" :class="dropdownClass" >
    <div class="ur-dropdown__title" :style="myStyle" @click="toggleItem" :class="dropdownTitleClass">
      <div class="ur-dropdown__selected" :title="getSelectedItemText" ><span>{{getSelectedItemText}}</span></div>
      <!--<div class="ur-dropdown__selected" :title="getSelectedItemText"><span>{{getSelectedItemText}}</span></div>-->
      <ur-icon-wrapper style="width:16px;margin-left:20px;">
        <ur-icon class="ur-dropdown__icon" icon="expand_menu" size="10px" :style="caretStyle" />
      </ur-icon-wrapper>
    </div>
    <div class="ur-dropdown__downwrap" v-show="isItemShowing" ref="floating" v-ur-attach-root v-click-outside.anchor="toggleItemOuter">
      <div v-if="searchable">
        <ur-text-field  class="ur-dropdown__item"  :style="myStyle" type="searchable"  v-model="inputText"   :placeholder="cInputPlaceholder" />
      </div>
      <div v-if="isShowFilterArea">
        <div class="ur-dropdown__item ur-dropdown__selectall" :style="myStyle" :class="[dropdownItemSize]" v-show="selectAll" @click="clickSelectAll">
          <ur-checkbox :checked="selectAllChecked" :checked-icon="selectAllCheckedIcon" @click="clickSelectAll">{{selectAllText}}</ur-checkbox>
        </div>
      </div>
      <div v-else>
        <div class="ur-dropdown__item ur-dropdown__selectall" :style="myStyle" :class="[dropdownItemSize]" v-show="selectAll" @click="clickSelectAllFilter">
        <ur-checkbox :checked="selectAllChecked" :checked-icon="selectAllCheckedFilterIcon" @click="clickSelectAllFilter">{{selectAllTextFilter}}</ur-checkbox>
      </div>
      </div>
      <div class="ur-dropdown__items" :style="myStyle">
        <div class="ur-dropdown__item" :class="[dropdownItemSize]" v-for="(item, idx) in filteredItems" :key="idx" @click="onClickItem(item)">
          <div class="ur-dropdown__label">
            <ur-checkbox :value="item" :checked="selected" :sm="$_size === 'small'" @click="onClickItem(item)">{{getText(item)}}</ur-checkbox>
          </div>
        </div>
      </div>
      <div class="ur-dropdown__apply ur-dropdown__apply_pos"  :style="myStyle" v-show="applyBtn">
        <ur-button shape="solid" small :disabled="disableFlag" primary @click="onApplyClick">확인</ur-button>
      </div> 
    </div>
    <div v-if="messageShow"
          class="ur-dropdown__message ur-validator__message"
          :class="messageClass">
      {{messageShow}}
    </div>
  </div>
</template>
<script>
  const UNSELECT_DROPDOWN_TITLE = "검색";
  const DEFAULT_PLACEHOLDER = "Input value";
  const DEFAULT_ITEM_TEXT = "text";
  const DEFAULT_ITEM_VALUE = "value";

  const NOT_SELECTED = -1;
  const NEED_CHECK   = -2;
  
  import urDropdown            from "../../../../node_modules/uidev-component/components/element/urDropdown/urDropdown";

  // ur-multi-dropdown은 ur-dropdown을 상속받은 컴포넌트 입니다. ur-dropdown의 모든 속성을 그대로 사용합니다.
  // #ur-multi-dropdown is a component that inherits ur-dropdown. Accept all the properties of ur-dropdown.
  export default {
    name: "ur-multi-dropdown-saas",
    extends: urDropdown,
    props: {
      // 드랍다운 리스트의 선택된 값 입니다.
      cInputPlaceholder:{
        type: String,
        default: '검색'
      },
      value: {
        type: Array,
        validator: function(val) {
          return Array.isArray(val);
        },
        default: () => []
      },
      // Apply 버튼을 표시합니다.
      applyBtn: {
        type: Boolean,
        default: true
      },
      // Select All 기능을 표시합니다.
      selectAll: {
        type: Boolean,
        default: false
      },
      selectAllText:{
        type: String,
        default: '전체'
      },
      selectAllTextFilter:{
        type: String,
        default: '검색결과 전체'
      },
      selectedAllText:{
        type: String,
        default: null,
      },
      // 선택가능 목록에 대한 data입니다.
      // Array type으로 전달될 경우 각각의 element는 이름과 값을 가지는 Object형태를 가져야합니다.
      // item-text, item-value의 기본값이 'text', 'value'이므로 {text: 'label', value: 'value'} 형태를 사용할 수 있습니다.  
      items: {
        type:[Array, Object],
          validator: function(val) {
            return Array.isArray(val);
          },
          default: ()=>[]
        },
      // 목록 필터 로직을 부여합니다.
      itemFilter : {
        type: Function
      },
      // $default: 'Input value'
      // 아무런 data도 선택되지 않았을 때 기본적으로 출력되는 메시지입니다.
      placeholder : {
        type: String, 
        default:UNSELECT_DROPDOWN_TITLE
      },
      // items에 전달된 데이터 Object에서 리스트에 출력될 값을 선택하는 key값입니다.
      itemText    : {
        type: [String, Function],
        default: DEFAULT_ITEM_TEXT
      },
      // items에 전달된 데이터 Object에서 item선택시 v-model에 전달될 값을 선택하는 key값입니다.
      itemValue   : {
        type: String , 
        default: DEFAULT_ITEM_VALUE
      },
      itemsSize   : {
        type: Number , 
        default: 560
      },
      searchable  : {
        type: Boolean ,
        default: true,
      },

    },
    data() {
      return {
        selected: [],
        filteredItems: this.items,
        inputText:'',
        allFlag:false,
        dropdownValue: this.value,
        initSelected: [],
        isShowFilterArea: true,
        disableFlag:false,
        dropdownProps: {
                    placeholder : this.placeholder,
                    itemText    :this.itemText,
                    itemValue   : this.itemValue,
                },
      }
    },
    watch: {
        isItemShowing(v,w) {
            if(v) {
                this.$refs.floating.open(); this.$emit('toggle-floating', true);;
            } else {
                this.$refs.floating.close(); this.$emit('toggle-floating', false);;
            }
            this.$emit('toggle-item', v);
        },
        items: {
            handler: function(newVal, oldVal) {
              // console.log('B');
              // console.log(this.items);
              this.allFlag=true;
              this.filter(this.inputText);
            },
            deep: true
        },
        inputText(newVal, oldVal) {
          /* if(newVal!=''|| newVal===undefined){            
            this.selected =[];
          } */
          this.selected = [];
          this.filter(newVal);
          
          if(newVal === ''){
            this.isShowFilterArea = true;            
            for(let index in this.items) {
              this.selected.push(this.items[index]);
            }
            this.disableFlag = false;
            this.dropdownValue = this.initSelected
          }else{
            this.isShowFilterArea = false;
            for(let index in this.filteredItems) {
              this.selected.push(this.filteredItems[index]);
            }
          }
        },
        dropdownValue(newVal, oldVal) {
            //this.$emit('input', newVal)
        },
             
    },
    computed: {
      myStyle() {
        return `width: ${this.itemsSize}px`
      },
      getSelectedItemText() {

        let _selected;
        if(this.applyBtn){
          _selected = this.initSelected;
        }else{
          _selected = this.selected;
        }
        // console.log(this.allFlag)
        if (_selected.length === 0) {
          return this.placeholder ? this.placeholder : UNSELECT_DROPDOWN_TITLE;
        } else {
          if(_selected.length === this.items.length||this.allFlag ) {
            this.allFlag = false;
            return this.selectedAllText || this.selectAllText;
          } else {
          let itemText = [];
          _selected.forEach(item => {
            /* if (typeof(this.itemText) === 'function') {
              itemText.push(this.itemText(item));
            } else {
              itemText.push(item[this.itemText]);
            } */
            itemText.push(item.text);
          });
          return itemText.sort().join(", ");
          }
          //return this.inputText;
        }
      },
      // cInputPlaceholder() {
      //  /*  console.log("this.initSelected : "+JSON.stringify(this.initSelected));
      //   console.log("this.selected : "+JSON.stringify(this.selected));
      //   console.log("this.items : "+JSON.stringify(this.items)); */
      //   return this.placeholder === 'Select' && this.valueTextMap.get(this.value) ? this.valueTextMap.get(this.value) :  this.placeholder;
      // },
      itemFilterFunc() {
        
          return function (text, val) {
            if(val===""||!val){
              return true;    
            }else{
              return text.toLowerCase().indexOf(val.toLowerCase()) > -1;
            }            
        }
      },
      selectAllChecked() {
        return (this.selected.length > 0);
      },
      selectAllCheckedIcon() {
        return (this.selected.length === this.items.length) ? 'checked' : 'indeterminate';
      },
      selectAllCheckedFilterIcon() {
        return (this.selected.length === this.filteredItems.length) ? 'checked' : 'indeterminate';
      },
      valueTextMap() {
        let rtn = new Map();
        for(let i = 0 ; i < this.items.length; i++) {
          let item = this.items[i];
          let value = typeof item === 'string' ? item : item[this.itemValue];
          let text = typeof item === 'string' ? item : item[this.itemText];
          rtn.set(value, text);
        }
        return rtn;
      },
    },
    created() {
      //초기값 표시 되게끔 selected에 넣어줌
      //this.selected = this.value
      this.selected = [];
      for(let index in this.items) {
        this.selected.push(this.items[index]);
      }

      let initItems = this.selected.map(initItem => {
        if(typeof initItem === 'string') {
          return initItem;
        } else if (typeof initItem === 'object') {
          return this.findItem(initItem);
        }
        return;
      })

      this.selected.length = 0
      initItems.forEach(item => this.selected.push(item));
      this.initSelected = this.selected.slice();
      this.$emit('input', this.selected);
      // 내용은 같은데 다른 객체일 경우 객체의 value 값 비교해서 넣어줌
    },
    methods: {
      onClickItem(item) {
       /*  console.log("item!!!!!!!!!!"+JSON.stringify(item));
        console.log("item!!!!!!!!!!"+JSON.stringify(this.selected)); */
        
        this.disableFlag = false;
        if (this.selected.indexOf(item) >= 0) {
          this.selected.splice(this.selected.indexOf(item), 1);
        } else {
          
          this.selected.push(item);
        }
        if(this.selected.length===0){
          this.disableFlag = true;
        }
        if (!this.applyBtn) {
          this.$emit('input', this.selected);
        }
        
      },
      filter(val) {
          let rtn = [];
         
          if(!val && (typeof val) != String) {
            this.filteredItems = this.items;
            return;
          }
          //let itemsClone = _.cloneDeep(this.items);
          let itemsClone = this.items;
          for(let i = 0 ; i < itemsClone.length; i++) {
            let item = itemsClone[i];
            //let text = typeof item === 'string' ? item : item[this.itemText];
            let text = item.text;
            if(this.itemFilterFunc(text, val)>0) {
              rtn.push(item);
              continue;
            }
          }
          this.filteredItems = rtn;
      },
      
      toggleItem(event) {
        // console.log(this.items);
        // console.log(this.selected);
        this.allFlag=false;
        let flag = !this.isItemShowing;
        if (this.applyBtn && flag) {
          this.selected = this.value.slice();
        }
        this.$root.$el.click();
        this.isItemShowing = flag;
      },
      toggleItemOuter(e) {
        this.disableFlag = false;
        this.isItemShowing = false;
      },
      onApplyClick(e) {
        
        this.$emit('input', this.selected.slice());
        this.isItemShowing = false;
        this.initSelected = this.selected.slice();
        this.inputText = "";
      },
      clickSelectAll(event) {
        if(this.inputText.trim()!="" ){
          this.selected = this.filteredItems.slice();
        }else{
          if (this.selected.length === this.items.length) {
            this.selected = [];
            this.disableFlag = true;
          } else {
            this.disableFlag = false;
            this.selected = this.items.slice();
          }
        }
        
        //this.$emit('input', this.selected)
      },
      clickSelectAllFilter(event) {
        if (this.selected.length === this.filteredItems.length) {
           this.disableFlag = true;
          this.selected = [];
        } else {
          this.disableFlag = false;
          this.selected = this.filteredItems.slice();
        }
      },
      findItem(val) {
        for(let i = 0 ; i < this.items.length ; i++) {
          let item = this.items[i];
          if(item['value'] === val['value']){
            return item;
          }
        }
        return null;
      },

    },
  }
</script>